// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__w9B4f","buttons":"RemoveExpirationActionButtons_buttons__2pA6F"};